import React, { useState } from 'react';
import Slide from 'react-reveal/Slide';
import Form from '../Others/Form';
import styles from './styles.module.scss';
import myImg from '../../assets/intro-bg.jpg';

function Introduction() {
	const [showForm, setShowForm] = useState(false);

	return (
		<Slide bottom>
			<div className={`box ${styles.introBox}`}>
				<h1 className='section-title'>Profile</h1>

				<div className={styles.innerContainer}>
					<img src={myImg} alt='my img' />
					<div className={styles.text}>
						<p>
							I am a computer science and engineering undergraduate student at
							the{' '}
							<a
								href='https://www.guc.edu.eg/'
								rel='noopener noreferrer'
								target='_blank'
							>
								German University in Cairo
							</a>{' '}
							(2017-2022), and a frontend developer at{' '}
							<a
								href='https://www.getspokn.com/'
								rel='noopener noreferrer'
								target='_blank'
							>
								Spokn
							</a>
							.
						</p>
						<p>
							Coding always has been my passion. I love using code to bring
							ideas to life. I found my enthusiasm growing towards web and
							mobile development, since then I never stopped learning new
							frameworks and technologies. I enjoy building projects, from small
							single-page applications to huge interactive apps. I never lose
							interest coding!
						</p>
						<p>
							Half of my time spent coding and the other half spent either in
							arts or searching for new interesting books to read{' '}
							<span role='img' aria-label='aria-label'>
								🤦🏻‍♀️
							</span>{' '}
							<span onClick={() => setShowForm(true)}>
								(recommend me a book!)
							</span>
							. I also enjoy travelling and exploring but I rarely do because I
							am a lazy introvert who prefers staying at home.
						</p>

						<p>
							My main sense of purpose in life is leaving things in a better
							shape than I have started.
						</p>
					</div>
				</div>
			</div>

			{showForm ? (
				<div className={styles.modalContainer}>
					<Form
						title='Recommend a book'
						type='Book'
						message='Note'
						button='Recommend this!'
						success='recommending me this book'
						setShowForm={setShowForm}
					></Form>
				</div>
			) : (
				<></>
			)}
		</Slide>
	);
}

export default Introduction;
